import { useState } from 'react';
import { Star } from 'lucide-react';

interface StarRating10Props {
  value: number;
  onChange: (value: number) => void;
  label: string;
}

// Valutazione 1-10 a stelline. 10 = punteggio migliore (come da documento MVP).
export default function StarRating10({ value, onChange, label }: StarRating10Props) {
  const [hovered, setHovered] = useState<number | null>(null);
  const active = hovered ?? value;

  return (
    <div className="rounded-2xl border border-border bg-card p-4 transition-colors sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-medium leading-snug text-foreground">{label}</p>
        <span
          className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-bold tabular-nums transition-colors ${
            value > 0
              ? 'bg-primary/10 text-primary'
              : 'bg-muted text-muted-foreground/60'
          }`}
        >
          {value > 0 ? `${value}/10` : '–'}
        </span>
      </div>

      <div
        className="mt-3 flex flex-wrap gap-1"
        role="radiogroup"
        aria-label={label}
        onMouseLeave={() => setHovered(null)}
      >
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={value === n}
            aria-label={String(n)}
            onClick={() => onChange(n)}
            onMouseEnter={() => setHovered(n)}
            className="rounded-md p-0.5 transition-transform duration-100 hover:scale-115 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <Star
              className={`size-6 transition-colors sm:size-7 ${
                n <= active
                  ? 'fill-amber-400 text-amber-400 drop-shadow-[0_1px_2px_rgba(251,191,36,0.35)]'
                  : 'fill-transparent text-muted-foreground/30'
              }`}
              strokeWidth={1.5}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
